"use client";

import { trackComponent } from "@repo/analytics";
import { dlEventConstants } from "@repo/analytics/data-layer.constants";
import React, { FC, useCallback } from "react";
import { handleRedirection } from "../../../utils/helper";
import { getCustomerIdForAnalytics } from "../../../utils/analytics-utils";
import { trendingStocksTrackAnalytics } from "../utils/trendingStocksCarouselAnalytics";

interface TrendingStocksInfoBannerProps {
  text?: string;
  ctaText?: string;
  ctaUrl?: string;
  sectionTitle?: string;
}

const TrendingStocksInfoBanner: FC<TrendingStocksInfoBannerProps> = ({
  text,
  ctaText,
  ctaUrl,
  sectionTitle = "Trending stocks",
}) => {
  const bannerText = text?.trim();
  const bannerCta = ctaText?.trim();

  const handleCtaClick = useCallback(() => {
    if (!ctaUrl) return;

    void (async () => {
      try {
        const customerId = await getCustomerIdForAnalytics();
        const trackPayload = {
          componentName: trendingStocksTrackAnalytics.componentNameCarousel,
          sectionTitle,
          eventType: dlEventConstants.CLICK,
          clickType: trendingStocksTrackAnalytics.clickTypes.infoBannerLink,
          ctaText: bannerCta,
          destinationUrl: ctaUrl,
          productCategory: trendingStocksTrackAnalytics.productCategory,
          cleverTapOverrides: {
            EP_PROPERTY_TYPE: trendingStocksTrackAnalytics.propertyType,
            EP_PRODUCT_NAME: trendingStocksTrackAnalytics.productName,
            EP_SPRINT: trendingStocksTrackAnalytics.sprint,
            EP_REFERENCE_ID: trendingStocksTrackAnalytics.referenceIdLinkClick,
            ...(customerId && { EP_CUSTOMER_ID: customerId }),
          },
        };
        await trackComponent(trackPayload);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to track trending stocks info banner CTA click", error);
      }
      handleRedirection(ctaUrl);
    })();
  }, [bannerCta, ctaUrl, sectionTitle]);

  if (!bannerText && !bannerCta) {
    return null;
  }

  return (
    <div className="px-4 py-3 md:py-4">
      <div className="flex w-full flex-col gap-1 rounded-[6px] border border-[#FFD000] bg-[#FFF5DA] p-2 opacity-100 md:min-h-[40px]">
        {bannerText && (
          <p className="text-[12px] md:text-[14px]  leading-[20px] text-[#666666]">{bannerText}</p>
        )}
        {bannerCta &&
          (ctaUrl ? (
            <button
              type="button"
              className="w-fit bg-transparent p-0 text-left text-[12px] font-medium text-[#FF6700] pointer-cursor"
              onClick={handleCtaClick}
            >
              {bannerCta}
            </button>
          ) : (
            <span className="w-fit text-[12px] font-medium text-[#FF6700]">
              {bannerCta}
            </span>
          ))}
      </div>
    </div>
  );
};

export default TrendingStocksInfoBanner;
